module.exports = __webpack_public_path__ + "img/progress-scribble-bar-color1.6c476afb.gif";